<template>
    <div class="beauty-page">

        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div>
                <div class="nav-title">科美 / 医美管理</div>
                <div class="nav-subtitle">
                    <span v-if="isSpecificStorePicked">{{ (storeList.find(s => String(s.id) === String(filterForm.storeid)) || {}).name }} · </span>{{ filteredList.length }} 位客户 · 今日预约 {{ statistics.todayAppoint }} 人
                </div>
            </div>
            <div class="nav-date">
                <div class="nav-date-day">{{ todayDay }}</div>
                <div class="nav-date-week">{{ todayWeek }}</div>
            </div>
        </div>

        <!-- 统计卡片 -->
        <div class="stat-grid">
            <div class="stat-item blue">
                <div class="stat-item-icon"><i class="el-icon-s-custom"></i></div>
                <div><div class="stat-item-val">{{ statistics.total }}</div><div class="stat-item-lbl">客户总数</div></div>
            </div>
            <div class="stat-item green">
                <div class="stat-item-icon"><i class="el-icon-magic-stick"></i></div>
                <div><div class="stat-item-val">{{ statistics.keimei }}</div><div class="stat-item-lbl">科美客户</div></div>
            </div>
            <div class="stat-item red">
                <div class="stat-item-icon"><i class="el-icon-first-aid-kit"></i></div>
                <div><div class="stat-item-val">{{ statistics.yimei }}</div><div class="stat-item-lbl">医美客户</div></div>
            </div>
            <div class="stat-item orange" :class="{ 'stat-active': todayOnly }" style="cursor:pointer" @click="toggleTodayOnly">
                <div class="stat-item-icon"><i class="el-icon-date"></i></div>
                <div>
                    <div class="stat-item-val">{{ statistics.todayAppoint }}</div>
                    <div class="stat-item-lbl">今日预约{{ todayOnly ? ' ✓' : '' }}</div>
                </div>
            </div>
        </div>

        <!-- 搜索栏 -->
        <div class="search-bar">
            <div class="search-input-wrap">
                <i class="el-icon-search"></i>
                <input v-model="searchKeyword" placeholder="搜索姓名或手机号" @input="handleSearch" />
                <i v-if="searchKeyword" class="el-icon-circle-close" style="cursor:pointer" @click="searchKeyword='';handleSearch()"></i>
            </div>
            <button class="filter-btn" @click="filterPanelVisible = true">
                <i class="el-icon-s-operation"></i>
                <span v-if="hasFilter" class="filter-dot"></span>
            </button>
        </div>

        <!-- 门店选择行（点击打开底部列表） -->
        <button type="button" class="store-select-row" :class="{ 'has-value': isSpecificStorePicked }" @click="openStorePicker">
            <i class="store-select-icon el-icon-office-building"></i>
            <span class="store-select-label">门店</span>
            <div class="store-select-divider"></div>
            <span class="store-select-value">{{ storeDisplayName }}</span>
            <i class="store-select-arrow el-icon-arrow-right"></i>
        </button>
        <div class="store-usedup-row">
            <label class="usedup-toggle">
                <input type="checkbox" v-model="showUsedUpCustomers" @change="onShowUsedUpChange" />
                <span>显示课程已用完的顾客</span>
            </label>
            <span class="usedup-hint">仅按当前门店与搜索生效</span>
        </div>

        <!-- 分类 Tab -->
        <div class="tab-bar">
            <div class="tab-item" :class="{ active: viewType === 'all' }" @click="switchTab('all')">全部<span class="tab-count">({{ statistics.total }})</span></div>
            <div class="tab-item" :class="{ active: viewType === '1' }" @click="switchTab('1')">科美<span class="tab-count">({{ statistics.keimei }})</span></div>
            <div class="tab-item" :class="{ active: viewType === '2' }" @click="switchTab('2')">医美<span class="tab-count">({{ statistics.yimei }})</span></div>
        </div>

        <!-- 客户列表 -->
        <div class="list-wrap">
            <div class="section-header">
                <span class="section-title">共 {{ filteredList.length }} 位客户</span>
                <span v-if="todayOnly" class="section-count today-tag" @click="toggleTodayOnly">今日预约 ×</span>
                <span v-else-if="hasFilter" class="section-count" @click="clearFilter">清除筛选 ×</span>
            </div>

            <div v-if="loading" class="loading-wrap">
                <i class="el-icon-loading" style="font-size:32px"></i>
                <div style="margin-top:8px">加载中...</div>
            </div>

            <div v-else-if="filteredList.length === 0" class="empty-wrap">
                <div class="empty-icon"><i class="el-icon-user"></i></div>
                <div class="empty-text">暂无客户数据</div>
            </div>

            <template v-else>
                <div v-for="cust in pagedList" :key="cust.memberid" class="customer-card" :class="cardClass(cust)">

                    <!-- 顶部信息 -->
                    <div class="card-top">
                        <div class="card-info">
                            <div class="card-name-row">
                                <span class="card-name">{{ cust.membername }}</span>
                                <span v-if="courseBadgeKm(cust)" class="card-type-badge keimei">科美</span>
                                <span v-if="courseBadgeYm(cust)" class="card-type-badge yimei">医美</span>
                            </div>
                            <div class="card-meta-row">
                                <span class="card-store"><i class="el-icon-office-building"></i>{{ cust.storename }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="!(cust.kmCourses && cust.kmCourses.length) && !(cust.ymCourses && cust.ymCourses.length)" class="cust-usedup-tip">
                        <i class="el-icon-warning-outline"></i> 科美、医美课程均已无剩余次数
                    </div>

                    <!-- 科美课程 + 科美预约（无科美课程则不显示整块） -->
                    <div v-if="displayKmCourses(cust).length" class="courses-block">
                        <div class="courses-type-title keimei">
                            <span class="dot"></span>科美课程
                            <span class="type-last-consume">
                <i class="el-icon-time"></i>
                最后消费：<span class="date-val">{{ cust.kmlastdate || '暂无' }}</span>
              </span>
                        </div>
                        <div v-for="(c, ci) in displayKmCourses(cust)" :key="(c.projectid || '') + '-' + ci" class="course-row">
                            <span class="course-name">{{ c.projectname }}</span>
                            <span class="course-rest-num" :class="courseRestClass(c.restnumber)">剩余 {{ c.restnumber }} 次</span>
                        </div>
                        <!-- 科美独立预约 -->
                        <div class="type-appoint-row keimei">
                            <template v-if="cust.kmRemind && cust.kmRemind.reminddate">
                                <div class="ta-head">
                                    <span class="ta-label keimei">科美预约</span>
                                    <span class="appoint-status-badge" :class="appointBadgeClass(remindStatus(cust.kmRemind))">{{ remindStatus(cust.kmRemind) }}</span>
                                    <button class="type-edit-btn keimei" @click="openAppoint(cust, 'keimei')"><i class="el-icon-edit"></i> 改约</button>
                                </div>
                                <div class="ta-time">
                                    <i class="el-icon-time ta-time-icon"></i>{{ cust.kmRemind.reminddate }} {{ cust.kmRemind.remindtime }}
                                </div>
                                <div v-if="cust.kmRemind.projectnames" class="ta-row">
                                    <span class="ta-row-lbl">项目</span>
                                    <span v-for="(pn,pi) in cust.kmRemind.projectnames.split(',')" :key="pi" class="appoint-proj-tag keimei-tag">{{ pn }}</span>
                                </div>
                                <div v-if="cust.kmRemind.remarks" class="ta-row">
                                    <span class="ta-row-lbl">备注</span>
                                    <span class="ta-row-val">{{ cust.kmRemind.remarks }}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="type-appoint-empty" @click="openAppoint(cust, 'keimei')">
                                    <i class="el-icon-plus"></i> 预约科美项目
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 医美课程 + 医美预约（无医美课程则不显示整块） -->
                    <div v-if="displayYmCourses(cust).length" class="courses-block">
                        <div class="courses-type-title yimei">
                            <span class="dot"></span>医美课程
                            <span class="type-last-consume">
                <i class="el-icon-time"></i>
                最后消费：<span class="date-val">{{ cust.ymlastdate || '暂无' }}</span>
              </span>
                        </div>
                        <div v-for="(c, ci) in displayYmCourses(cust)" :key="(c.projectid || '') + '-' + ci" class="course-row">
                            <span class="course-name">{{ c.projectname }}</span>
                            <span class="course-rest-num" :class="courseRestClass(c.restnumber)">剩余 {{ c.restnumber }} 次</span>
                        </div>
                        <!-- 医美独立预约 -->
                        <div class="type-appoint-row yimei">
                            <template v-if="cust.ymRemind && cust.ymRemind.reminddate">
                                <div class="ta-head">
                                    <span class="ta-label yimei">医美预约</span>
                                    <span class="appoint-status-badge" :class="appointBadgeClass(remindStatus(cust.ymRemind))">{{ remindStatus(cust.ymRemind) }}</span>
                                    <button class="type-edit-btn yimei" @click="openAppoint(cust, 'yimei')"><i class="el-icon-edit"></i> 改约</button>
                                </div>
                                <div class="ta-time">
                                    <i class="el-icon-time ta-time-icon"></i>{{ cust.ymRemind.reminddate }} {{ cust.ymRemind.remindtime }}
                                </div>
                                <div v-if="cust.ymRemind.projectnames" class="ta-row">
                                    <span class="ta-row-lbl">项目</span>
                                    <span v-for="(pn,pi) in cust.ymRemind.projectnames.split(',')" :key="pi" class="appoint-proj-tag yimei-tag">{{ pn }}</span>
                                </div>
                                <div v-if="cust.ymRemind.remarks" class="ta-row">
                                    <span class="ta-row-lbl">备注</span>
                                    <span class="ta-row-val">{{ cust.ymRemind.remarks }}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="type-appoint-empty" @click="openAppoint(cust, 'yimei')">
                                    <i class="el-icon-plus"></i> 预约医美项目
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 操作按钮 -->
                    <div class="card-actions">
                        <button type="button" class="action-btn record" @click="openRecord(cust)"><i class="el-icon-document"></i> 消费记录</button>
                        <button type="button" class="action-btn appoint-hist" @click="openAppointHistory(cust)"><i class="el-icon-date"></i> 预约历史</button>
                    </div>
                </div>

                <div class="load-more" ref="loadMoreEl" @click="hasMore && loadMore()">
                    <template v-if="hasMore">
                        <i class="el-icon-loading"></i> 加载中…
                    </template>
                    <template v-else>— 已显示全部 —</template>
                </div>
            </template>
        </div>

        <!-- ===== 筛选面板 ===== -->
        <div v-if="filterPanelVisible" class="panel-mask" @click.self="filterPanelVisible = false">
            <div class="bottom-panel">
                <div class="panel-handle"></div>
                <div class="panel-title">筛选条件</div>
                <div class="panel-body">
                    <div class="panel-label"><i class="el-icon-office-building"></i> 门店</div>
                    <button type="button" class="store-panel-trigger" :class="{ active: isSpecificStorePicked }" @click="openStorePicker">
                        <i class="panel-select-icon el-icon-office-building"></i>
                        <span class="store-panel-trigger-text">{{ storeDisplayName }}</span>
                        <i class="store-select-arrow el-icon-arrow-right"></i>
                    </button>
                    <div class="panel-label">课程类型</div>
                    <div class="panel-chips">
            <span v-for="t in [['全部',''],['科美','1'],['医美','2']]" :key="t[0]"
                  class="panel-chip" :class="{ active: filterForm.projectBigType === t[1] }"
                  @click="filterForm.projectBigType = t[1]">{{ t[0] }}</span>
                    </div>
                    <div class="panel-label">预约状态</div>
                    <div class="panel-chips">
            <span v-for="s in ['全部','待预约','已预约']" :key="s"
                  class="panel-chip" :class="{ active: filterForm.appointStatus === (s === '全部' ? '' : s) }"
                  @click="filterForm.appointStatus = (s === '全部' ? '' : s)">{{ s }}</span>
                    </div>
                    <div class="panel-label">余量预警</div>
                    <div class="panel-chips">
            <span class="panel-chip" :class="{ active: filterForm.lowRemain }" @click="filterForm.lowRemain = !filterForm.lowRemain">
              余量不足（≤2次）
            </span>
                    </div>
                </div>
                <div class="panel-footer">
                    <button class="panel-reset-btn" @click="resetFilter">重置</button>
                    <button class="panel-confirm-btn" @click="applyFilter">确认筛选</button>
                </div>
            </div>
        </div>

        <!-- ===== 门店选择底部弹层 ===== -->
        <div v-if="storePickerVisible" class="panel-mask store-picker-mask" @click.self="storePickerVisible = false">
            <div class="store-picker-sheet" @click.stop>
                <div class="panel-handle"></div>
                <div class="store-picker-head">
                    <span class="store-picker-title">选择门店</span>
                    <button type="button" class="store-picker-close" @click="storePickerVisible = false">取消</button>
                </div>
                <div class="store-picker-scroll">
                    <button
                        v-for="store in storeList"
                        :key="store.id"
                        type="button"
                        class="store-picker-option"
                        :class="{ selected: isStoreSelected(store.id) }"
                        @click="pickStore(store.id)"
                    >
                        <span class="store-picker-option-name">{{ store.name }}</span>
                        <i v-if="isStoreSelected(store.id)" class="el-icon-check store-picker-check"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- ===== 预约面板 ===== -->
        <div v-if="appointVisible" class="panel-mask" @click.self="appointVisible = false">
            <div class="appoint-panel">
                <div class="panel-handle" style="background:#e4e7ed"></div>
                <div class="appoint-header">
                    <div class="appoint-customer-bar">
                        <div>
                            <div class="appoint-customer-name">{{ currentCust ? currentCust.membername : '' }}</div>
                            <div class="appoint-customer-meta">
                <span class="card-type-badge" :class="appointForm.appointType">
                  {{ appointForm.appointType === 'keimei' ? '科美' : '医美' }}预约
                </span>
                                <i class="el-icon-office-building" style="font-size:12px;color:#909399;margin-left:6px"></i>
                                <span class="appoint-customer-phone">{{ currentCust ? currentCust.storename : '' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="appoint-scroll">
                    <div class="form-section">
                        <!-- 预约项目 -->
                        <div class="form-row">
                            <div class="form-lbl">预约项目 <span class="req">*</span>
                                <span v-if="appointForm.selectedProjects.length" style="font-size:11px;font-weight:700;margin-left:6px"
                                      :style="{ color: appointForm.appointType === 'keimei' ? '#27ae60' : '#e74c3c' }">
                  已选{{ appointForm.selectedProjects.length }}项
                </span>
                            </div>
                            <div v-for="c in appointTypeCourses" :key="c.projectid"
                                 class="proj-check-item" :class="[appointForm.appointType, { checked: isProjectSelected(c), disabled: c.restnumber <= 0 }]"
                                 @click="toggleProject(c)">
                                <div class="proj-checkbox">
                                    <span v-if="isProjectSelected(c)">✓</span>
                                </div>
                                <div class="proj-info">
                                    <div class="proj-name">{{ c.projectname }}</div>
                                    <div class="proj-remain" :class="{ warn: c.restnumber <= 2 }">剩余 {{ c.restnumber }} 次</div>
                                </div>
                            </div>
                            <div v-if="!appointTypeCourses.length" class="no-proj-tip">该客户暂无此类型可用课程</div>
                        </div>

                        <!-- 预约日期 + 时间（原生控件）-->
                        <div class="form-row">
                            <div class="form-lbl">预约日期 <span class="req">*</span></div>
                            <input type="date" v-model="appointForm.appointDate"
                                   class="form-ctrl native-date" :min="minDate" />
                        </div>
                        <div class="form-row">
                            <div class="form-lbl">
                                预约时间 <span class="req">*</span>
                                <span v-if="appointForm.appointHour" class="selected-hour-tip">{{ appointForm.appointHour }}</span>
                            </div>
                            <div class="time-slot-grid">
                                <button v-for="slot in TIME_SLOTS" :key="slot"
                                        type="button" class="time-slot-btn"
                                        :class="[{ active: appointForm.appointHour === slot }, appointForm.appointType]"
                                        @click="appointForm.appointHour = slot">
                                    {{ slot }}
                                </button>
                            </div>
                        </div>

                        <!-- 备注 -->
                        <div class="form-row">
                            <div class="form-lbl">备注</div>
                            <textarea v-model="appointForm.remark" class="form-textarea" rows="3" placeholder="注意事项..." maxlength="200"></textarea>
                            <div class="form-counter">{{ appointForm.remark.length }}/200</div>
                        </div>
                    </div>
                    <div style="height:16px"></div>
                </div>

                <div class="appoint-footer">
                    <button class="appoint-cancel-btn" @click="appointVisible = false">取消</button>
                    <button class="appoint-submit-btn" :disabled="saving" @click="submitAppoint">
                        <span v-if="saving"><i class="el-icon-loading"></i> 提交中…</span>
                        <span v-else><i class="el-icon-check"></i> 确认{{ appointForm.appointType === 'keimei' ? '科美' : '医美' }}预约</span>
                    </button>
                </div>
            </div>
        </div>


        <!-- ===== 消费记录面板 ===== -->
        <div v-if="recordVisible" class="panel-mask" @click.self="recordVisible = false">
            <div class="record-panel">
                <div class="record-panel-header">
                    <div class="panel-handle"></div>
                    <div class="record-panel-title">{{ currentCust ? currentCust.membername : '' }} · 消费记录</div>
                    <button class="record-close-btn" @click="recordVisible = false"><i class="el-icon-close"></i></button>
                </div>
                <div class="record-scroll" v-if="currentCust">
                    <div v-if="currentCust.records && currentCust.records.length" class="record-list">
                        <div v-for="(r, idx) in currentCust.records" :key="idx" class="record-item" :class="r.billtype === 2 ? 'ri-yimei' : 'ri-keimei'">
                            <div class="ri-left-bar"></div>
                            <div class="ri-body">
                                <div class="ri-top">
                                    <span class="ri-type-tag" :class="r.billtype === 2 ? 'yimei' : 'keimei'">{{ r.billtype === 2 ? '医美' : '科美' }}</span>
                                    <span class="ri-project">{{ r.projectname }}</span>
                                    <span class="ri-count">×{{ r.number }}</span>
                                </div>
                                <div class="ri-bottom">
                                    <span class="ri-store"><i class="el-icon-office-building"></i>{{ r.storename }}</span>
                                    <span class="ri-date"><i class="el-icon-date"></i>{{ (r.accountdate || '').substring(0, 10) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="empty-wrap">
                        <div class="empty-icon"><i class="el-icon-document"></i></div>
                        <div class="empty-text">暂无消费记录</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ===== 预约历史面板 ===== -->
        <div v-if="appointHistoryVisible" class="panel-mask" @click.self="appointHistoryVisible = false">
            <div class="record-panel">
                <div class="record-panel-header">
                    <div class="panel-handle"></div>
                    <div class="record-panel-title">{{ currentCust ? currentCust.membername : '' }} · 预约历史</div>
                    <button class="record-close-btn" @click="appointHistoryVisible = false"><i class="el-icon-close"></i></button>
                </div>
                <div class="record-scroll" v-if="currentCust">
                    <div v-if="currentCust.appointRecords && currentCust.appointRecords.length" class="ah-list">
                        <div
                            v-for="(a, idx) in sortedAppointRecords(currentCust.appointRecords)"
                            :key="a.id != null ? a.id : idx"
                            class="ah-item"
                            :class="Number(a.type) === 2 ? 'ah-yimei' : 'ah-keimei'"
                        >
                            <div class="ah-row-line1">
                <span class="ri-type-tag" :class="Number(a.type) === 2 ? 'yimei' : 'keimei'">
                  {{ Number(a.type) === 2 ? '医美' : '科美' }}
                </span>
                                <span class="ah-when-inline">{{ formatAppointHistoryWhen(a) }}</span>
                            </div>
                            <div class="ah-kv-row">
                                <span class="ah-kv-label">项目</span>
                                <div class="ah-kv-value ah-kv-projs">
                                    <template v-if="splitProjectNames(a.projectnames).length">
                    <span
                        v-for="(pn, pi) in splitProjectNames(a.projectnames)"
                        :key="pi"
                        class="ah-val-pill"
                        :class="Number(a.type) === 2 ? 'ah-pill-ym' : 'ah-pill-km'"
                    >{{ pn }}</span>
                                    </template>
                                    <span v-else class="ah-val-plain ah-val-muted">—</span>
                                </div>
                            </div>
                            <div class="ah-kv-row">
                                <span class="ah-kv-label">备注</span>
                                <span class="ah-val-plain">{{ (a.remarks && String(a.remarks).trim()) ? String(a.remarks).trim() : '—' }}</span>
                            </div>
                            <div v-if="a.createtorname && String(a.createtorname).trim()" class="ah-meta">
                                {{ String(a.createtorname).trim() }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="empty-wrap">
                        <div class="empty-icon"><i class="el-icon-date"></i></div>
                        <div class="empty-text">暂无预约记录</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import moment from 'moment'

/** 从 localStorage 读取门店 id，作为默认（全量）storeid */
const ALL_DATA_STORE_ID = localStorage.getItem('storeid') || ''

const STORE_LIST = []

export default {
    name: 'BeautyManagement',
    data() {
        return {
            loading: false,
            customerList: [],
            searchKeyword: '',
            viewType: 'all',
            filterForm: { storeid: ALL_DATA_STORE_ID, projectBigType: '', appointStatus: '', lowRemain: false },
            storeList: STORE_LIST,
            statistics: { total: 0, keimei: 0, yimei: 0, todayAppoint: 0 },
            pageSize: 5,
            currentPage: 1,

            filterPanelVisible: false,
            storePickerVisible: false,
            appointVisible: false,
            recordVisible: false,
            appointHistoryVisible: false,
            currentCust: null,
            saving: false,

            todayOnly: false,
            showUsedUpCustomers: false,
            appointForm: { appointType: 'keimei', selectedProjects: [], appointDate: '', appointHour: '', remark: '' },
            TIME_SLOTS: ['08:30','09:00','09:30','10:00','10:30','11:00','11:30',
                '13:00','13:30','14:00','14:30','15:00','15:30',
                '16:00','16:30','17:00','17:30','18:00']
        }
    },

    computed: {
        hasFilter() {
            const f = this.filterForm
            const storeFiltered = f.storeid && String(f.storeid) !== ALL_DATA_STORE_ID
            return this.todayOnly || this.showUsedUpCustomers || storeFiltered || f.projectBigType || f.appointStatus || f.lowRemain
        },
        isSpecificStorePicked() {
            return !!this.filterForm.storeid && String(this.filterForm.storeid) !== ALL_DATA_STORE_ID
        },
        minDate() {
            return moment().format('YYYY-MM-DD')
        },
        filteredList() {
            const f = this.filterForm
            const kw = this.searchKeyword.trim()

            if (this.showUsedUpCustomers) {
                let list = this.customerList.filter(c => !(c.kmCourses && c.kmCourses.length) && !(c.ymCourses && c.ymCourses.length))
                if (kw) list = list.filter(c => (c.membername && c.membername.includes(kw)) || (c.memberphone && String(c.memberphone).includes(kw)))
                if (this.isSpecificStorePicked) list = list.filter(c => c.storeid === f.storeid)
                return list
            }

            let list = this.customerList
            list = list.filter(c => (c.kmCourses && c.kmCourses.length) || (c.ymCourses && c.ymCourses.length))
            if (kw) list = list.filter(c => (c.membername && c.membername.includes(kw)) || (c.memberphone && String(c.memberphone).includes(kw)))
            if (this.viewType === '1') list = list.filter(c => c.kmCourses && c.kmCourses.length)
            if (this.viewType === '2') list = list.filter(c => c.ymCourses && c.ymCourses.length)
            if (this.isSpecificStorePicked) list = list.filter(c => c.storeid === f.storeid)
            if (f.projectBigType === '1') list = list.filter(c => c.kmCourses && c.kmCourses.length)
            if (f.projectBigType === '2') list = list.filter(c => c.ymCourses && c.ymCourses.length)
            if (f.appointStatus === '已预约') {
                list = list.filter(c => ['已预约', '已逾期'].includes(this.custAppointStatus(c)))
            } else if (f.appointStatus) {
                list = list.filter(c => this.custAppointStatus(c) === f.appointStatus)
            }
            if (f.lowRemain)              list = list.filter(c => [...(c.kmCourses||[]), ...(c.ymCourses||[])].some(cc => cc.restnumber <= 2 && cc.restnumber > 0))
            if (this.todayOnly) {
                const today = moment().format('YYYY-MM-DD')
                list = list.filter(c =>
                    (c.kmRemind && c.kmRemind.reminddate === today) ||
                    (c.ymRemind && c.ymRemind.reminddate === today)
                )
            }
            return list
        },
        pagedList() {
            console.log(this.filteredList)
            return this.filteredList.slice(0, this.currentPage * this.pageSize)
        },
        hasMore()   {
            console.log(this.pagedList.length < this.filteredList.length)
            return this.pagedList.length < this.filteredList.length
        },
        todayDay() {
            return moment().format('M/D')
        },
        todayWeek() {
            const WEEKS = ['周日','周一','周二','周三','周四','周五','周六']
            return WEEKS[moment().day()]
        },
        appointTypeCourses() {
            if (!this.currentCust) return []
            return this.appointForm.appointType === 'keimei'
                ? this.currentCust.kmCourses
                : this.currentCust.ymCourses
        },
        storeDisplayName() {
            const s = this.storeList.find(x => String(x.id) === String(this.filterForm.storeid))
            return s ? s.name : '选择门店'
        }
    },

    created() {
        this.fetchStores()
        this.fetchCustomers()
    },

    mounted() {
        this._onScroll = () => {
            if (!this.hasMore || this._loadingMore) return
            const scrolled = window.scrollY
                || document.documentElement.scrollTop
                || document.body.scrollTop
                || 0
            const total = Math.max(
                document.documentElement.scrollHeight,
                document.body.scrollHeight
            )
            if (total - scrolled - window.innerHeight < 150) {
                this.loadMore()
            }
        }
        window.addEventListener('scroll', this._onScroll, { passive: true })
        document.addEventListener('scroll', this._onScroll, { passive: true })
        document.body.addEventListener('scroll', this._onScroll, { passive: true })
    },
    beforeDestroy() {
        if (this._onScroll) {
            window.removeEventListener('scroll', this._onScroll)
            document.removeEventListener('scroll', this._onScroll)
            document.body.removeEventListener('scroll', this._onScroll)
        }
    },

    methods: {
        openStorePicker() {
            this.storePickerVisible = true
        },
        isStoreSelected(id) {
            return String(this.filterForm.storeid || '') === String(id || '')
        },
        pickStore(id) {
            if (id == null || id === '') return
            this.filterForm.storeid = id
            this.storePickerVisible = false
            this.handleSearch()
            this.fetchCustomers()
        },
        fetchStores() {
            this.$post('/store/getStoreInfoByStructsOpen', {
                storeid: ALL_DATA_STORE_ID
            }).then(res => {
                if (res && res.sucess) {
                    const list = res.object || res.data || []
                    this.storeList = list.map(s => ({ id: s.brandid, name: s.brandname }))
                }
            })
        },
        fetchCustomers() {
            this.loading = true
            const params = {
                storeid: this.filterForm.storeid || ALL_DATA_STORE_ID,
                mth:12,
                params: this.searchKeyword || '',
                type: 0,
                resulttype: 1
            }
            this.$post('/kmym/getKmYmCustInfo', params).then(res => {
                if (res && res.sucess) {
                    const list = res.object || res.data || []
                    const activeCourses = arr => (arr || []).filter(c => Number(c.restnumber) > 0)
                    this.customerList = list
                        .map(item => ({
                            ...item,
                            kmCoursesAll: item.kmCourses || [],
                            ymCoursesAll: item.ymCourses || [],
                            kmCourses: activeCourses(item.kmCourses),
                            ymCourses: activeCourses(item.ymCourses),
                            records: item.records || []
                        }))
                } else {
                    this.customerList = []
                }
                this.calcStatistics()
            }).catch(() => {
                this.customerList = []
            }).finally(() => {
                this.loading = false
                /* 数据加载完成后主动检查一次，避免内容不足一屏时底部可见却没触发 scroll */
                this.$nextTick(() => { this._onScroll && this._onScroll() })
            })
        },
        calcStatistics() {
            const today = moment().format('YYYY-MM-DD')
            const hasKmRemain = c => c.kmCourses && c.kmCourses.length
            const hasYmRemain = c => c.ymCourses && c.ymCourses.length
            this.statistics = {
                total: this.customerList.filter(c => hasKmRemain(c) || hasYmRemain(c)).length,
                keimei: this.customerList.filter(hasKmRemain).length,
                yimei:  this.customerList.filter(hasYmRemain).length,
                todayAppoint: this.customerList.filter(c =>
                    (c.kmRemind && c.kmRemind.reminddate === today) ||
                    (c.ymRemind && c.ymRemind.reminddate === today)
                ).length
            }
        },
        handleSearch()  { this.currentPage = 1 },
        switchTab(t)    { this.viewType = t; this.currentPage = 1 },
        applyFilter()   { this.filterPanelVisible = false; this.currentPage = 1 },
        resetFilter()   { this.filterForm = { storeid: this.filterForm.storeid, projectBigType: '', appointStatus: '', lowRemain: false } },
        clearFilter()   { this.resetFilter(); this.todayOnly = false; this.showUsedUpCustomers = false; this.currentPage = 1 },
        onShowUsedUpChange() {
            if (this.showUsedUpCustomers) this.viewType = 'all'
            this.currentPage = 1
        },
        toggleTodayOnly() { this.todayOnly = !this.todayOnly; this.currentPage = 1 },
        loadMore() {
            console.log(this._loadingMore);
            console.log(this.hasMore);
            if (!this.hasMore || this._loadingMore) return
            this._loadingMore = true
            setTimeout(() => {
                this.currentPage++
                this._loadingMore = false
            }, 300)
        },

        courseRestClass(n) {
            const r = Number(n)
            if (r <= 0) return 'exhausted'
            if (r <= 2) return 'warn'
            return 'ok'
        },
        displayKmCourses(cust) {
            if (this.showUsedUpCustomers) return cust.kmCoursesAll || []
            return cust.kmCourses || []
        },
        displayYmCourses(cust) {
            if (this.showUsedUpCustomers) return cust.ymCoursesAll || []
            return cust.ymCourses || []
        },
        courseBadgeKm(cust) {
            if (this.showUsedUpCustomers) return cust.kmCoursesAll && cust.kmCoursesAll.length
            return cust.kmCourses && cust.kmCourses.length
        },
        courseBadgeYm(cust) {
            if (this.showUsedUpCustomers) return cust.ymCoursesAll && cust.ymCoursesAll.length
            return cust.ymCourses && cust.ymCourses.length
        },
        appointBadgeClass(status) {
            return { '已预约': 'success', '已逾期': 'danger', '待预约': 'info', '已完成': 'info' }[status] || 'info'
        },
        remindStatus(remind) {
            if (!remind || !remind.reminddate) return '待预约'
            const today = moment().format('YYYY-MM-DD')
            const d = String(remind.reminddate).substring(0, 10)
            return d < today ? '已逾期' : '已预约'
        },
        /** 预约历史列表：按预约日期+时段从新到旧 */
        sortedAppointRecords(list) {
            if (!list || !list.length) return []
            const key = a => {
                const d = String(a.reminddate || '').substring(0, 10)
                const t = String(a.remindtime || '')
                return d + ' ' + t
            }
            return [...list].sort((a, b) => key(b).localeCompare(key(a)))
        },
        formatAppointHistoryWhen(a) {
            const dateLine = (() => {
                const d = String(a.reminddate || '').substring(0, 10)
                if (!d || d.length < 8) return '日期待完善'
                const m = moment(d, 'YYYY-MM-DD', true)
                return m.isValid() ? m.format('YYYY年M月D日') : d
            })()
            const d = String(a.reminddate || '').substring(0, 10)
            const m = moment(d, 'YYYY-MM-DD', true)
            const week = m.isValid()
                ? ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][m.day()]
                : ''
            const t = a.remindtime && String(a.remindtime).trim() ? String(a.remindtime).trim() : ''
            let out = dateLine
            if (week) out += ` ${week}`
            if (t) out += ` ${t}`
            return out
        },
        splitProjectNames(str) {
            if (str == null || str === '') return []
            return String(str)
                .split(/[,，、]/)
                .map(s => s.trim())
                .filter(Boolean)
        },
        custAppointStatus(c) {
            const statuses = [this.remindStatus(c.kmRemind), this.remindStatus(c.ymRemind)]
            if (statuses.includes('已逾期')) return '已逾期'
            if (statuses.includes('已预约')) return '已预约'
            return '待预约'
        },
        cardClass(c) {
            const s = this.custAppointStatus(c)
            if (s === '已逾期') return 'overdue'
            if ([...(c.kmCourses||[]), ...(c.ymCourses||[])].some(cc => cc.restnumber <= 2 && cc.restnumber > 0)) return 'low-warn'
            if (s === '已预约') return 'booked'
            if (s === '待预约') return 'no-appoint'
            return ''
        },

        openAppoint(cust, type) {
            this.currentCust = cust
            const existing = type === 'keimei' ? cust.kmRemind : cust.ymRemind
            const names = existing?.projectnames ? existing.projectnames.split(',') : []
            const courses = type === 'keimei' ? cust.kmCourses : cust.ymCourses
            let preSelected = names.map(pname => {
                const found = (courses || []).find(c => c.projectname === pname)
                return found ? { projectid: found.projectid, projectname: found.projectname, projectbigtype: found.projectbigtype, restnumber: found.restnumber, consumeCount: 1 } : null
            }).filter(Boolean)
            const available = (courses || []).filter(c => c.restnumber > 0)
            if (!preSelected.length && available.length === 1) {
                const c = available[0]
                preSelected = [{ projectid: c.projectid, projectname: c.projectname, projectbigtype: c.projectbigtype, restnumber: c.restnumber, consumeCount: 1 }]
            }
            this.appointForm = {
                appointType: type,
                selectedProjects: preSelected,
                appointDate: existing?.reminddate || '',
                appointHour: existing?.remindtime || '',
                remark: existing?.remarks || ''
            }
            this.appointVisible = true
        },
        isProjectSelected(course) {
            return this.appointForm.selectedProjects.some(p => p.projectid === course.projectid)
        },
        toggleProject(course) {
            if (course.restnumber <= 0) return
            const idx = this.appointForm.selectedProjects.findIndex(p => p.projectid === course.projectid)
            if (idx > -1) {
                this.appointForm.selectedProjects.splice(idx, 1)
            } else {
                this.appointForm.selectedProjects.push({
                    projectid: course.projectid,
                    projectname: course.projectname,
                    projectbigtype: course.projectbigtype,
                    restnumber: course.restnumber,
                    consumeCount: 1
                })
            }
        },
        submitAppoint() {
            if (!this.appointForm.selectedProjects.length) return this.$message.warning('请至少选择一个预约项目')
            if (!this.appointForm.appointDate) return this.$message.warning('请选择预约日期')
            if (!this.appointForm.appointHour) return this.$message.warning('请选择预约时间')
            this.saving = true
            const type = this.appointForm.appointType
            const params = {
                storeid: this.currentCust.storeid || '',
                type: type === 'keimei' ? 1 : 2,
                memberid: this.currentCust.memberid,
                projectids: this.appointForm.selectedProjects.map(p => p.projectid).join(','),
                projectnames: this.appointForm.selectedProjects.map(p => p.projectname).join(','),
                reminddate: this.appointForm.appointDate,
                remindtime: this.appointForm.appointHour,
                remarks: this.appointForm.remark || ''
            }
            this.$postw('/kmym/saveKmYmRemind', params).then(res => {
                if (res && res.sucess) {
                    const cust = this.customerList.find(c => c.memberid === this.currentCust.memberid)
                    if (cust) {
                        const remindObj = { reminddate: params.reminddate, remindtime: params.remindtime, projectids: params.projectids, projectnames: params.projectnames, remarks: params.remarks }
                        if (type === 'keimei') cust.kmRemind = remindObj
                        else                   cust.ymRemind = remindObj
                    }
                    this.appointVisible = false
                    this.calcStatistics()
                    this.$message.success('预约登记成功！')
                }
            }).catch(() => {
                this.$message.error('预约保存失败')
            }).finally(() => {
                this.saving = false
            })
        },

        openRecord(cust) {
            this.currentCust = cust
            this.appointHistoryVisible = false
            this.$set(this.currentCust, 'records', [])
            this.recordVisible = true
            const mid = cust.memberid
            this.$post('/kmym/getCardTransacTionHistoryByMemberId', { memberid: mid }).then(res => {
                if (res && res.sucess) {
                    this.$set(this.currentCust, 'records', res.object || res.data || [])
                }
            })
        },
        openAppointHistory(cust) {
            this.currentCust = cust
            this.recordVisible = false
            this.$set(this.currentCust, 'appointRecords', [])
            this.appointHistoryVisible = true
            const mid = cust.memberid
            this.$post('/kmym/getKmYmRemindByMemberId', { memberid: mid }).then(res => {
                if (res && res.sucess) {
                    let list = res.object != null ? res.object : res.data
                    if (list != null && !Array.isArray(list)) list = [list]
                    this.$set(this.currentCust, 'appointRecords', Array.isArray(list) ? list : [])
                }
            })
        }
    }
}
</script>

<style>
/* ===== 页面容器 ===== */
.beauty-page {
    max-width: 480px;
    margin: 0 auto;
    min-height: 100vh;
    background: #f0f2f5;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 14px;
    position: relative;
    padding-bottom: 24px;
}

/* ===== 顶部导航栏 ===== */
.nav-bar {
    position: sticky; top: 0; z-index: 100;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 0 18px; height: 58px;
    display: flex; align-items: center; justify-content: space-between;
    box-shadow: 0 3px 16px rgba(102,126,234,.45);
}
.nav-title    { color: #fff; font-size: 18px; font-weight: 700; letter-spacing: .3px; }
.nav-subtitle { color: rgba(255,255,255,.72); font-size: 11px; margin-top: 2px; }
.nav-date { text-align: right; }
.nav-date-day  { color: #fff; font-size: 20px; font-weight: 700; line-height: 1; }
.nav-date-week { color: rgba(255,255,255,.7); font-size: 11px; margin-top: 2px; text-align: center; }

/* ===== 统计卡片 ===== */
.stat-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding: 14px 14px 6px; }
.stat-item {
    border-radius: 14px; padding: 14px 14px 13px;
    display: flex; align-items: center; gap: 12px;
    color: #fff; box-shadow: 0 4px 14px rgba(0,0,0,.12);
    transition: transform .2s;
}
.stat-item.blue   { background: linear-gradient(135deg, #4facfe 0%, #00b4d8 100%); }
.stat-item.green  { background: linear-gradient(135deg, #43e97b 0%, #1db954 100%); }
.stat-item.red    { background: linear-gradient(135deg, #f857a6 0%, #f5576c 100%); }
.stat-item.orange { background: linear-gradient(135deg, #f7971e 0%, #fda833 100%); }
.stat-item.stat-active { box-shadow: 0 0 0 3px rgba(255,255,255,.9), 0 6px 20px rgba(0,0,0,.2); transform: scale(1.05); }
.stat-item-icon { font-size: 30px; opacity: .9; flex-shrink: 0; }
.stat-item-val  { font-size: 28px; font-weight: 800; line-height: 1; }
.stat-item-lbl  { font-size: 12px; opacity: .9; margin-top: 4px; font-weight: 500; }

/* ===== 搜索 + 筛选栏 ===== */
.search-bar { margin: 12px 14px 0; display: flex; align-items: center; gap: 8px; }
.search-input-wrap {
    flex: 1; height: 42px; background: #fff;
    border-radius: 21px; display: flex; align-items: center;
    padding: 0 16px; gap: 8px;
    box-shadow: 0 1px 8px rgba(0,0,0,.07);
    border: 1.5px solid transparent; transition: border-color .2s;
}
.search-input-wrap:focus-within { border-color: #667eea; }
.search-input-wrap i { color: #b8bfcc; font-size: 16px; }
.search-input-wrap input {
    flex: 1; border: none; outline: none; font-size: 14px; color: #303133; background: transparent;
}
.search-input-wrap input::placeholder { color: #c0c4cc; }
.filter-btn {
    width: 42px; height: 42px; border-radius: 50%;
    background: #fff; border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; color: #667eea; box-shadow: 0 1px 8px rgba(0,0,0,.07); position: relative;
}
.filter-dot { position: absolute; top: 7px; right: 7px; width: 8px; height: 8px; border-radius: 50%; background: #f56c6c; border: 1.5px solid #fff; }

/* ===== 分类 Tab ===== */
.tab-bar {
    display: flex; padding: 10px 14px 2px; gap: 8px;
}
.tab-item {
    flex: 1; height: 36px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 600; cursor: pointer;
    background: #fff; color: #909399; border: none;
    box-shadow: 0 1px 4px rgba(0,0,0,.06); transition: all .2s;
}
.tab-item.active {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff; box-shadow: 0 3px 12px rgba(102,126,234,.4);
}
.tab-count { font-size: 11px; margin-left: 3px; opacity: .8; }

/* ===== 列表区 ===== */
.list-wrap { padding: 10px 14px 0; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.section-title { font-size: 13px; color: #adb5bd; font-weight: 500; }
.section-count { font-size: 13px; color: #409eff; font-weight: 600; cursor: pointer; }
.section-count.today-tag { color: #f7971e; }

/* ===== 客户卡片 ===== */
.customer-card {
    background: #fff; border-radius: 16px; margin-bottom: 12px;
    box-shadow: 0 2px 14px rgba(0,0,0,.07); overflow: hidden; position: relative;
    border-left: 4px solid transparent; transition: transform .15s;
}
.customer-card.overdue    { border-left-color: #f56c6c; }
.customer-card.low-warn   { border-left-color: #e6a23c; }
.customer-card.no-appoint { border-left-color: #d0d7e3; }
.customer-card.booked     { border-left-color: #67c23a; }

.card-top { padding: 14px 14px 10px; display: flex; align-items: center; gap: 12px; }
.card-info { flex: 1; min-width: 0; }
.card-name-row { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.card-name { font-size: 16px; font-weight: 700; color: #1a1a1a; }
.card-meta-row {
    display: flex; align-items: center; gap: 6px;
    margin-top: 5px; flex-wrap: wrap;
}
.card-store { font-size: 12px; color: #9aa3b0; display: flex; align-items: center; gap: 3px; }
.card-store i { font-size: 12px; }
.card-type-badge {
    height: 19px; padding: 0 8px; border-radius: 10px;
    font-size: 10px; font-weight: 700; color: #fff; letter-spacing: .3px;
    display: inline-flex; align-items: center; flex-shrink: 0;
}
.card-type-badge.keimei { background: linear-gradient(135deg, #2ecc71, #27ae60); }
.card-type-badge.yimei  { background: linear-gradient(135deg, #e74c3c, #c0392b); }

/* ===== 预约状态徽标 ===== */
.appoint-status-badge {
    height: 20px; padding: 0 8px; border-radius: 10px; font-size: 11px;
    display: inline-flex; align-items: center; font-weight: 500;
}
.appoint-status-badge.success { background: #f0f9eb; color: #67c23a; }
.appoint-status-badge.danger  { background: #fef0f0; color: #f56c6c; }
.appoint-status-badge.info    { background: #f4f4f5; color: #909399; }

/* ===== 预约项目标签 ===== */
.appoint-projs-line {
    display: flex; align-items: flex-start; gap: 5px; flex-wrap: wrap;
    margin-top: 6px; font-size: 12px; color: #606266;
}
.appoint-proj-tag {
    display: inline-block; background: #f0f2ff; color: #667eea;
    border: 1px solid #d0d7f8; border-radius: 4px;
    padding: 1px 7px; font-size: 11px; font-weight: 600; margin: 2px 2px 0 0;
}
.appoint-proj-tag.keimei-tag { background: #f0faf4; color: #27ae60; border-color: #b7e4ca; }
.appoint-proj-tag.yimei-tag  { background: #fff0f0; color: #e74c3c; border-color: #f5c6c6; }

.appoint-remark-line {
    display: flex; align-items: flex-start; gap: 5px;
    margin-top: 7px; padding-top: 7px;
    border-top: 1px dashed #dde3f5;
    font-size: 12px; color: #606266; line-height: 1.6;
}
.appoint-remark-icon { color: #a0aee8; font-size: 13px; flex-shrink: 0; margin-top: 1px; }
.appoint-remark-lbl  { color: #a0aee8; font-weight: 600; white-space: nowrap; flex-shrink: 0; }

/* ===== 课程块内独立预约行 ===== */
/* ===== 预约信息块 ===== */
.type-appoint-row {
    margin: 8px 0 4px; padding: 10px 12px;
    border-radius: 10px; border: 1.5px dashed #d0d7f8; background: #fafbff;
}
.type-appoint-row.yimei { border-color: #f5c6c6; background: #fff8f8; }

/* 第一行：标签 + 状态 + 改约 */
.ta-head {
    display: flex; align-items: center; gap: 6px; margin-bottom: 7px;
}
.ta-label {
    font-size: 11px; font-weight: 700; letter-spacing: .3px; flex-shrink: 0;
}
.ta-label.keimei { color: #27ae60; }
.ta-label.yimei  { color: #e74c3c; }
.ta-head .appoint-status-badge { flex-shrink: 0; }
.type-edit-btn {
    margin-left: auto; flex-shrink: 0; height: 24px; padding: 0 10px;
    border-radius: 6px; border: 1.5px solid #d0d7f8;
    background: #fff; color: #667eea; font-size: 11px; font-weight: 600;
    cursor: pointer; display: flex; align-items: center; gap: 3px;
}
.type-edit-btn.yimei { border-color: #f5c6c6; color: #e74c3c; }
.type-edit-btn:active { opacity: .75; }

/* 第二行：时间 */
.ta-time {
    display: flex; align-items: center; gap: 5px;
    font-size: 13px; font-weight: 700; color: #303133;
    margin-bottom: 6px;
}
.ta-time-icon { font-size: 13px; color: #adb5bd; flex-shrink: 0; }

/* 项目 / 备注行 */
.ta-row {
    display: flex; align-items: flex-start; gap: 6px;
    margin-top: 5px; flex-wrap: wrap;
}
.ta-row-lbl {
    flex-shrink: 0; font-size: 11px; color: #adb5bd;
    background: #f0f2f5; border-radius: 4px;
    padding: 1px 6px; line-height: 18px; margin-top: 2px;
}
.ta-row-val { font-size: 12px; color: #606266; line-height: 1.6; flex: 1; }

.type-appoint-empty {
    display: flex; align-items: center; justify-content: center; gap: 5px;
    color: #667eea; font-size: 13px; font-weight: 600; cursor: pointer; padding: 2px 0;
}
.type-appoint-row.yimei .type-appoint-empty { color: #e74c3c; }

/* ===== 课程区块 ===== */
.courses-block { padding: 0 14px 10px; border-top: 1px solid #f0f2f5; }
.courses-type-title {
    font-size: 11px; font-weight: 700; letter-spacing: .5px;
    display: flex; align-items: center; gap: 5px;
    margin-bottom: 8px; margin-top: 10px;
}
.courses-type-title .dot { width: 7px; height: 7px; border-radius: 50%; }
.courses-type-title.keimei { color: #27ae60; }
.courses-type-title.keimei .dot { background: #27ae60; }
.courses-type-title.yimei  { color: #e74c3c; }
.courses-type-title.yimei  .dot { background: #e74c3c; }
.type-last-consume {
    margin-left: auto; font-size: 11px; font-weight: 400;
    display: flex; align-items: center; gap: 3px;
}
.courses-type-title.keimei .type-last-consume { color: #8ecda7; }
.courses-type-title.yimei  .type-last-consume { color: #e8a0a0; }
.type-last-consume .date-val { font-weight: 700; }

.course-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 8px 12px; border-radius: 10px; margin-bottom: 6px;
    background: #f7f8fc;
}
.courses-block:last-of-type .course-row:last-of-type { background: #f7f8fc; }
.course-name { font-size: 13px; font-weight: 600; color: #303133; flex: 1; min-width: 0; }
.course-rest-num { font-size: 13px; font-weight: 700; white-space: nowrap; margin-left: 8px; padding: 2px 10px; border-radius: 20px; }
.course-rest-num.warn { color: #e6a23c; background: #fff8f0; }
.course-rest-num.ok   { color: #3db05e; background: #f0faf4; }
.course-rest-num.exhausted { color: #909399; background: #f0f2f5; font-weight: 600; }

/* ===== 操作按钮行 ===== */
.card-actions {
    padding: 10px 14px 13px; display: flex; gap: 8px;
    border-top: 1px solid #f0f2f5;
}
.action-btn {
    flex: 1; height: 36px; border-radius: 10px; border: none;
    display: flex; align-items: center; justify-content: center;
    gap: 5px; font-size: 13px; font-weight: 600; cursor: pointer; transition: opacity .15s;
}
.action-btn:active { opacity: .7; }
.action-btn.remind { background: #fff8ef; color: #e6a23c; border: 1px solid #fce6c4; }
.action-btn.record { background: #f0faf4; color: #3db05e; border: 1px solid #c0e8cf; }
.action-btn.appoint-hist { background: #f0f2ff; color: #667eea; border: 1px solid #d4dcff; }

/* ===== 加载/空状态 ===== */
.loading-wrap { text-align: center; padding: 48px 0; color: #c0c4cc; }
.empty-wrap   { text-align: center; padding: 56px 0; }
.empty-icon   { font-size: 64px; color: #dcdfe6; }
.empty-text   { font-size: 14px; color: #c0c4cc; margin-top: 12px; }
.load-more { text-align: center; padding: 16px; font-size: 13px; color: #c0c4cc; letter-spacing: .3px; display: flex; align-items: center; justify-content: center; gap: 6px; }

/* ===== 通用蒙层 + 底部面板 ===== */
.panel-mask { position: fixed; inset: 0; background: rgba(0,0,0,.5); z-index: 200; }
.bottom-panel {
    position: fixed; bottom: 0; left: 0; right: 0;
    max-width: 480px; margin: 0 auto;
    background: #fff; border-radius: 22px 22px 0 0;
    z-index: 201; animation: slideUp .28s cubic-bezier(.4,0,.2,1);
    /* 小屏 / iPhone：限制高度，避免底部按钮被裁切；dvh 规避 Safari 地址栏导致 100vh 偏大 */
    max-height: calc(100vh - 20px);
    max-height: calc(100dvh - 20px);
    display: flex;
    flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    box-sizing: border-box;
}
@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
.panel-handle { width: 38px; height: 4px; background: #e4e7ed; border-radius: 2px; margin: 12px auto 4px; flex-shrink: 0; }
.panel-title  { font-size: 16px; font-weight: 700; color: #1a1a1a; padding: 10px 18px 12px; flex-shrink: 0; }
.panel-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    padding: 0 18px 12px;
}
.panel-label  {
    font-size: 12px; color: #909399; font-weight: 700; letter-spacing: .4px;
    text-transform: uppercase; margin-bottom: 8px; margin-top: 16px;
}
.panel-chips  { display: flex; flex-wrap: wrap; gap: 8px; }
.panel-chip {
    height: 34px; padding: 0 16px; border-radius: 17px;
    border: 1.5px solid #e8eaf0; background: #f7f8fc;
    font-size: 13px; color: #606266; cursor: pointer; transition: all .15s;
    display: inline-flex; align-items: center; justify-content: center;
}
.panel-chip.active { border-color: #667eea; background: #f0f2ff; color: #667eea; font-weight: 700; }
.panel-footer {
    display: flex; gap: 10px; flex-shrink: 0;
    padding: 12px 18px 16px;
    border-top: 1px solid #f0f2f5;
    background: #fff;
}
.panel-reset-btn {
    flex: 1; height: 46px; border-radius: 12px; border: 1.5px solid #e4e7ed;
    background: #fff; color: #606266; font-size: 14px; cursor: pointer; font-weight: 500;
}
.panel-confirm-btn {
    flex: 2; height: 46px; border-radius: 12px; border: none;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff; font-size: 14px; font-weight: 700; cursor: pointer;
}

/* ===== 门店选择行（打开底部列表） ===== */
.store-select-row {
    display: flex; align-items: center; gap: 10px;
    margin: 10px 14px 0; background: #fff; border-radius: 12px;
    padding: 12px 14px; min-height: 48px; width: calc(100% - 28px); box-sizing: border-box;
    box-shadow: 0 1px 6px rgba(0,0,0,.08);
    border: none; cursor: pointer; text-align: left; font: inherit;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
}
.store-select-row:active { opacity: .92; transform: scale(.995); }
.store-select-icon  { font-size: 17px; color: #667eea; flex-shrink: 0; }
.store-select-label { font-size: 13px; color: #606266; white-space: nowrap; flex-shrink: 0; }
.store-select-divider { width: 1px; height: 18px; background: #e4e7ed; flex-shrink: 0; }
.store-select-value {
    flex: 1; min-width: 0; font-size: 15px; font-weight: 600; color: #303133;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.store-select-arrow { font-size: 14px; color: #c0c4cc; flex-shrink: 0; }
.store-select-row.has-value .store-select-label { color: #667eea; font-weight: 600; }
.store-select-row.has-value .store-select-icon  { color: #667eea; }
.store-select-row.has-value .store-select-value { color: #667eea; }

.store-usedup-row {
    margin: 8px 14px 0;
    padding: 0 4px 6px;
    display: flex; flex-wrap: wrap; align-items: center; gap: 6px 14px;
}
.usedup-toggle {
    display: inline-flex; align-items: center; gap: 8px;
    font-size: 13px; color: #606266; cursor: pointer; user-select: none;
}
.usedup-toggle input { width: 16px; height: 16px; accent-color: #667eea; cursor: pointer; flex-shrink: 0; }
.usedup-hint { font-size: 11px; color: #c0c4cc; line-height: 1.3; }

.cust-usedup-tip {
    margin: 0 14px 10px; padding: 10px 12px; background: #fdf6ec; border-radius: 10px;
    font-size: 12px; color: #b88230; display: flex; align-items: center; gap: 6px;
}

/* 筛选面板：门店入口（与主页共用底部弹层） */
.store-panel-trigger {
    display: flex; align-items: center; width: 100%;
    min-height: 48px; padding: 0 12px; box-sizing: border-box;
    border: 1.5px solid #e4e7ed; border-radius: 12px; background: #fff;
    cursor: pointer; font: inherit; text-align: left;
    -webkit-tap-highlight-color: transparent; touch-action: manipulation;
}
.store-panel-trigger:active { background: #f7f8fc; }
.store-panel-trigger.active { border-color: #667eea; background: #f0f2ff; }
.panel-select-icon { padding: 0 6px 0 0; font-size: 15px; color: #909399; flex-shrink: 0; }
.store-panel-trigger.active .panel-select-icon { color: #667eea; }
.store-panel-trigger-text {
    flex: 1; min-width: 0; font-size: 16px; font-weight: 600; color: #303133;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.store-panel-trigger.active .store-panel-trigger-text { color: #667eea; }

/* ===== 门店底部弹层 ===== */
.store-picker-mask { z-index: 300; }
.store-picker-sheet {
    position: fixed; left: 0; right: 0; bottom: 0; max-width: 480px; margin: 0 auto;
    background: #fff; border-radius: 20px 20px 0 0; z-index: 301;
    max-height: min(72vh, 520px);
    display: flex; flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    box-sizing: border-box;
    animation: slideUp .28s cubic-bezier(.4,0,.2,1);
}
.store-picker-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 4px 16px 12px; flex-shrink: 0; border-bottom: 1px solid #f0f2f5;
}
.store-picker-title { font-size: 16px; font-weight: 700; color: #303133; }
.store-picker-close {
    border: none; background: transparent; color: #667eea; font-size: 15px;
    font-weight: 600; padding: 8px 4px; cursor: pointer; -webkit-tap-highlight-color: transparent;
}
.store-picker-scroll {
    flex: 1; min-height: 0; overflow-y: auto; -webkit-overflow-scrolling: touch;
    padding: 8px 12px 16px;
}
.store-picker-option {
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    width: 100%; min-height: 52px; padding: 14px 16px; margin-bottom: 6px;
    border: none; border-radius: 12px; background: #f7f8fc;
    font: inherit; text-align: left; cursor: pointer; box-sizing: border-box;
    -webkit-tap-highlight-color: transparent; touch-action: manipulation;
}
.store-picker-option:active { filter: brightness(.97); }
.store-picker-option.selected {
    background: #f0f2ff; box-shadow: inset 0 0 0 1.5px #667eea;
}
.store-picker-option-name { font-size: 16px; font-weight: 600; color: #303133; flex: 1; }
.store-picker-option.selected .store-picker-option-name { color: #667eea; }
.store-picker-check { font-size: 18px; color: #667eea; font-weight: 700; flex-shrink: 0; }

/* ===== 预约面板 ===== */
.appoint-panel {
    position: fixed; bottom: 0; left: 0; right: 0; max-width: 480px; margin: 0 auto;
    background: #fff; border-radius: 22px 22px 0 0; z-index: 201;
    animation: slideUp .28s cubic-bezier(.4,0,.2,1);
    max-height: 92vh; display: flex; flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom);
}
.appoint-header { padding: 0 18px; border-bottom: 1px solid #f0f2f5; flex-shrink: 0; }
.appoint-customer-bar { display: flex; align-items: center; gap: 12px; padding: 14px 0 12px; }
.appoint-customer-name { font-size: 17px; font-weight: 700; color: #1a1a1a; }
.appoint-customer-meta { display: flex; align-items: center; gap: 8px; margin-top: 3px; }
.appoint-customer-phone { font-size: 12px; color: #909399; }
.appoint-scroll { flex: 1; overflow-y: auto; padding: 0 18px; -webkit-overflow-scrolling: touch; }
.form-section { margin-top: 16px; }
.form-row   { margin-bottom: 14px; }
.form-lbl   { font-size: 13px; color: #606266; margin-bottom: 6px; }
.form-lbl .req { color: #f56c6c; margin-left: 2px; }
.form-ctrl {
    width: 100%; height: 42px; border: 1.5px solid #e4e7ed; border-radius: 10px;
    padding: 0 12px; font-size: 14px; color: #303133; outline: none;
    background: #fff; appearance: none; -webkit-appearance: none;
}
.form-ctrl:focus { border-color: #667eea; }
.form-textarea {
    width: 100%; border: 1.5px solid #e4e7ed; border-radius: 10px;
    padding: 10px 12px; font-size: 14px; color: #303133; outline: none;
    resize: none; font-family: inherit; background: #fff;
}
.form-textarea:focus { border-color: #667eea; }
.form-counter { font-size: 12px; color: #c0c4cc; text-align: right; margin-top: 3px; }

/* 项目多选 */
.proj-check-item {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 12px; border-radius: 10px; margin-bottom: 6px;
    border: 1.5px solid #e4e7ed; background: #fff; cursor: pointer; transition: all .15s;
}
.proj-check-item.checked { border-color: #667eea; background: #f0f2ff; }
.proj-check-item.disabled { opacity: .45; cursor: not-allowed; }
.proj-checkbox {
    width: 20px; height: 20px; border-radius: 6px; flex-shrink: 0;
    border: 2px solid #dcdfe6; background: #fff;
    display: flex; align-items: center; justify-content: center; transition: all .15s;
}
.proj-check-item.checked .proj-checkbox { background: #667eea; border-color: #667eea; color: #fff; font-size: 13px; }
.proj-check-item.keimei.checked .proj-checkbox { background: #27ae60; border-color: #27ae60; }
.proj-check-item.yimei.checked  .proj-checkbox { background: #e74c3c; border-color: #e74c3c; }
.proj-info   { flex: 1; min-width: 0; }
.proj-name   { font-size: 13px; font-weight: 600; color: #303133; }
.proj-remain { font-size: 11px; color: #909399; margin-top: 2px; }
.proj-remain.warn { color: #e6a23c; font-weight: 600; }
.no-proj-tip { text-align: center; font-size: 13px; color: #c0c4cc; padding: 16px 0; }

.appoint-footer { padding: 12px 18px 18px; border-top: 1px solid #f0f2f5; flex-shrink: 0; display: flex; gap: 10px; }
.appoint-cancel-btn {
    width: 80px; height: 48px; border-radius: 12px; border: 1.5px solid #e4e7ed;
    background: #fff; color: #606266; font-size: 14px; cursor: pointer;
}
.appoint-submit-btn {
    flex: 1; height: 48px; border-radius: 12px; border: none;
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: #fff; font-size: 15px; font-weight: 700; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 6px;
}

/* ===== 微信提醒面板 ===== */

/* ===== 消费记录面板 ===== */
.record-panel {
    position: fixed; bottom: 0; left: 0; right: 0; max-width: 480px; margin: 0 auto;
    background: #f0f2f5; border-radius: 22px 22px 0 0; z-index: 201;
    animation: slideUp .28s cubic-bezier(.4,0,.2,1);
    max-height: 85vh; display: flex; flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom);
}
.record-panel-header {
    background: #fff; border-radius: 22px 22px 0 0; padding: 0 18px 14px;
    flex-shrink: 0; position: relative;
}
.record-panel-title { font-size: 16px; font-weight: 700; color: #303133; padding-top: 14px; padding-right: 36px; }
.record-close-btn {
    position: absolute; top: 14px; right: 18px;
    width: 28px; height: 28px; border-radius: 50%; background: #f4f5f7;
    border: none; font-size: 16px; color: #606266; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
}
.record-scroll { flex: 1; overflow-y: auto; padding: 12px 14px; -webkit-overflow-scrolling: touch; }
.record-list { display: flex; flex-direction: column; gap: 10px; }
.record-item {
    background: #fff; border-radius: 12px; padding: 0; display: flex; overflow: hidden;
    box-shadow: 0 1px 4px rgba(0,0,0,.05);
}
.ri-left-bar { width: 4px; flex-shrink: 0; border-radius: 4px 0 0 4px; }
.ri-keimei .ri-left-bar { background: linear-gradient(180deg, #27ae60, #6dd5a0); }
.ri-yimei  .ri-left-bar { background: linear-gradient(180deg, #e74c3c, #f5a0a0); }
.ri-body { flex: 1; padding: 12px 14px; display: flex; flex-direction: column; gap: 8px; }
.ri-top { display: flex; align-items: center; gap: 8px; }
.ri-type-tag {
    font-size: 10px; font-weight: 700; padding: 2px 7px; border-radius: 6px;
    flex-shrink: 0; letter-spacing: .5px;
}
.ri-type-tag.keimei { background: #e8f8ef; color: #27ae60; }
.ri-type-tag.yimei  { background: #fde8e8; color: #e74c3c; }
.ri-project { font-size: 14px; font-weight: 600; color: #303133; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ri-count {
    font-size: 13px; font-weight: 700; color: #606266; background: #f4f5f7;
    padding: 1px 8px; border-radius: 8px; flex-shrink: 0;
}
.ri-bottom { display: flex; align-items: center; gap: 14px; font-size: 12px; color: #909399; }
.ri-bottom i { margin-right: 3px; font-size: 12px; }
.ri-store { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ri-date { flex-shrink: 0; margin-left: auto; }
.ri-project-multi { white-space: normal; text-overflow: unset; font-weight: 500; line-height: 1.35; }

/* ===== 预约历史（简约列表） ===== */
.ah-list { display: flex; flex-direction: column; gap: 10px; }
.ah-item {
    background: #fff; border-radius: 12px; padding: 12px 14px;
    box-shadow: 0 1px 4px rgba(0,0,0,.06);
    border-left: 3px solid #dcdfe6;
}
.ah-keimei { border-left-color: #27ae60; }
.ah-yimei  { border-left-color: #e74c3c; }
.ah-row-line1 {
    display: flex; align-items: center; flex-wrap: wrap; gap: 8px 10px; margin-bottom: 12px;
}
.ah-when-inline {
    font-size: 15px; font-weight: 700; color: #303133; line-height: 1.4;
    flex: 1; min-width: 0;
}
.ah-kv-row {
    display: flex; align-items: flex-start; gap: 10px; margin-top: 10px;
}
.ah-kv-row:first-of-type { margin-top: 0; }
.ah-kv-label {
    flex-shrink: 0; margin-top: 2px;
    font-size: 12px; font-weight: 600; color: #909399;
    padding: 4px 10px; border-radius: 999px; background: #eef0f4;
    line-height: 1.3;
}
.ah-kv-value { flex: 1; min-width: 0; display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.ah-val-pill {
    font-size: 13px; font-weight: 600; padding: 5px 12px; border-radius: 999px; line-height: 1.35;
}
.ah-pill-km {
    color: #1e8449; background: #ecf9f0; border: 1px solid #7dcea0;
}
.ah-pill-ym {
    color: #a93226; background: #fdf2f1; border: 1px solid #f5b7b1;
}
.ah-val-plain { font-size: 14px; color: #3d4d5c; line-height: 1.5; word-break: break-word; padding-top: 3px; }
.ah-val-muted { color: #c0c4cc; }
.ah-meta { font-size: 12px; color: #c0c4cc; margin-top: 10px; }

/* ===== 时间段快选 ===== */
.time-slot-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.time-slot-btn {
    height: 38px; border-radius: 10px; border: 1.5px solid #e8eaf0;
    background: #f7f8fc; color: #606266; font-size: 13px; font-weight: 600;
    cursor: pointer; transition: all .15s;
}
.time-slot-btn:active { opacity: .75; }
.time-slot-btn.active { color: #fff; border-color: transparent; box-shadow: 0 3px 10px rgba(102,126,234,.35); background: linear-gradient(135deg,#667eea,#764ba2); }
.time-slot-btn.keimei.active { background: linear-gradient(135deg,#43e97b,#27ae60); box-shadow: 0 3px 10px rgba(39,174,96,.35); }
.time-slot-btn.yimei.active  { background: linear-gradient(135deg,#f857a6,#f5576c); box-shadow: 0 3px 10px rgba(245,87,108,.35); }

/* ===== 原生日期框美化 ===== */
.native-date {
    font-size: 15px; color: #303133; cursor: pointer;
    -webkit-appearance: none;
}
.native-date::-webkit-calendar-picker-indicator {
    opacity: .5; cursor: pointer; filter: invert(30%);
}

.selected-hour-tip {
    margin-left: 8px; font-size: 12px; font-weight: 700;
    color: #667eea; background: #f0f2ff; padding: 1px 8px; border-radius: 10px;
}

/* ===== Element UI 覆写 ===== */
.el-switch { transform: scale(.9); }
</style>



// WEBPACK FOOTER //
// src/page/kmym/index.vue